export default __webpack_public_path__ + "static/media/MFaktor greY.209575cc.png";